import { Component, ElementRef, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss']
})
export class FormGroupComponent {
  @Input() title: string;
  @Input() icon: string;
  @Input() titleTemplate: TemplateRef<ElementRef>;
  @Input() subtitle?: string;
  @Input() fullWidth?: boolean;
  @Input() isCard?: boolean;
  @Input() isCardHeader?: boolean;
}
